__turbopack_context__.v({
  "question-list": "question-list-module-scss-module__7CJ6Mq__question-list",
});
